/*
 * Copyright (c) 2026, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import { formatEnum } from "../../utils/format-enum"
import { formatJSON } from "../../utils/format-json"

import type { ApplicationEvent } from "./application-detail-types"

/**
 * Formats an event's result and detector parameters for display.
 *
 * The result appears first, followed by the formatted parameters. Each part
 * starts on its own line; `formatJSON` preserves the parameters' line breaks.
 *
 * @param event - The event result and parameters.
 * @returns The formatted text, or an empty string when neither is present.
 *
 * @example
 * formatEventParameters({ result: "NOT_PASSED", parameters: { attempts: 3 } })
 * // "result: Not passed\nattempts: 3"
 */
export function formatEventParameters({ result, parameters }: Pick<ApplicationEvent, "result" | "parameters">): string {
    return [result && `result: ${formatEnum(result)}`, formatJSON(parameters)].filter(Boolean).join("\n")
}
